$(window).on('load', () => {
  const navElement = document.querySelectorAll('.half__nav__item');
  if (navElement.length) {
    navElement.forEach(item => {
      if (item.classList.contains('active')) {
        activeNav(item, navElement);
      }
      item.addEventListener('click', function(e) {
        activeNav(item, navElement);
      });
    });
  }
});
function activeNav(item, allItems) {
  const itemDescription = item.querySelector('.half__nav__content');
  const itemDescriptionHeight = itemDescription
    .querySelector('p')
    .getBoundingClientRect().height;
  const allContent = document.querySelectorAll('.half_nav_content__wrapper');
  const itemData = item.dataset.title;
  allItems.forEach(item => {
    item.classList.remove('active');
    const itemDescription = item.querySelector('.half__nav__content');
    itemDescription.style.maxHeight = '0';
  });
  item.classList.add('active');
  itemDescription.style.maxHeight = itemDescriptionHeight + 'px';
  allContent.forEach(element => {
    const elementData = element.dataset.content;
    if (elementData == itemData) {
      // const elemntHeight = element.children[0].getBoundingClientRect().height;
      const elemntHeight = item.closest('.half').getBoundingClientRect().height;
      let more = 0;
      if (window.innerWidth < 1350) {
        more = 30;
      }
      if (window.innerWidth < 1200) {
        more = 120;
      }
      console.log(more);
      console.log(elemntHeight);
      element.classList.add('active');
      element.style.maxHeight = more + elemntHeight + 'px';
      // console.log(elemntHeight);
    } else {
      element.classList.remove('active');
      element.style.maxHeight = 0;
    }
  });
}
